import type { GridColDef } from "@mui/x-data-grid-premium";
import { GRID_CHECKBOX_SELECTION_COL_DEF } from "@mui/x-data-grid-premium";
import CheckboxGridCell from "./CheckboxGridCell";
import CheckboxGridColumnHeader from "./CheckboxGridColumnHeader";

interface Configuration {
  groupsSelectionOnly?: boolean;
}

const createCheckboxColumn = (config?: Configuration): GridColDef => {
  const { groupsSelectionOnly } = config || {};

  return {
    ...GRID_CHECKBOX_SELECTION_COL_DEF,
    renderHeader: (params) => <CheckboxGridColumnHeader params={params} />,
    renderCell: (params) => <CheckboxGridCell params={params} groupsSelectionOnly={groupsSelectionOnly} />,
  };
};

export default createCheckboxColumn;
